<template>
  <div class="preview-wechat-container flex vertical">
    <span class="font-12 color-white" style="position: absolute; top: 96px; left: 35px;">{{ $day(data.wageMonth).format('YYYY年M月') }}工资明细</span>
    <div class="flex vertical center" style="margin-top: 130px;">
      <span class="font-16 color-white">{{ $showMoney(data.netPay) }}</span>
      <span class="font-12 color-white mt18 mb15">实发工资</span>
      <span class="font-12 color-white">Net Pay</span>
    </div>
    <div class="list-container flex vertical">
      <template v-for="group in data.list">
        <div class="flex acenter w100 fhpx30">
          <div class="group-line"></div>
          <span class="font-12" style="color: #08245B;">{{ group.title }}</span>
        </div>
        <div class="flex vertical p10 bg-white">
          <div v-for="item in group.itemList" class="item-box flex jbetween acenter mb15">
            <span class="font-12 text-left text-ellipsis" style="min-width: 100px; max-width: 190px;">{{ item.name }}</span>
            <span class="font-12 text-right ">{{ item.money }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.preview-wechat-container {
  width: 331px;
  height: 662px;
  flex: 0 0 662px;
  background: url('~@/assets/img/v2/service-process/微信预览背景.png') no-repeat;
  background-size: 100% 100%;
  position: relative;

  .list-container {
    background: #FAFAFA;
    width: 263px;
    height: 414px;
    overflow-y: auto;
    margin-top: 24px;
    margin-left: 23px;
    padding: 0 10px;
    border-radius: 0 0 30px 30px;

    .group-line {
      width: 3px;
      flex: 0 0 3px;
      height: 20px;
      background-color: #08245B;
      margin-right: 10px;
    }
    .item-box:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
